import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { FlightSidebarPackages_flight$key } from '__generated__/FlightSidebarPackages_flight.graphql';

type Props = {
  flight: FlightSidebarPackages_flight$key;
};

const FlightSidebarPackages: FC<Props> = ({ flight }) => {
  const { packages } = useFragment(
    graphql`
      fragment FlightSidebarPackages_flight on Flight {
        packages {
          id
          name
        }
      }
    `,
    flight
  );

  return (
    <>
      {packages.map(({ id, name }) => (
        <Box key={id}>
          <Link href={`/packages/${id}`} target="_blank">
            {name}
          </Link>
        </Box>
      ))}
    </>
  );
};

export default FlightSidebarPackages;
